<template>
  <v-container fluid id="docForm" class="subtitle-2 text--primary">
    <div v-show="sellOnline == 'Y'">
      <v-card>
        <v-toolbar dense flat color="secondary">
          <v-toolbar-title>Create Sale</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense id="po">
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-autocomplete autocomplete="off" dense outlined v-model="record.CardCode" :items="customers"
                label="Customer" item-text="Name" item-value="id" :search-input.sync="searchCustomers">
                <template v-if="enableCreate" v-slot:no-data>
                  <v-row align="center" justify="center">
                    <v-btn :loading="searchingProduct" class="ma-2" color="accent" dark small elevation="0"
                      @click="customerModal()">
                      <v-icon left>mdi-plus</v-icon>Create A Customer
                    </v-btn>
                  </v-row>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="4" xs="4" md="4">
              <span style="font-weight: bold; font-size: 18px;">Invoice#: {{ DocNum }}</span>
            </v-col>

            <v-col cols="8" xs="8" md="4">
              <DatePicker v-if="canBackDate == 'Y'" @date="setDate" :myDate="date" :title="`Date`" ref="dateRef">
              </DatePicker>
              <span v-else class="style-16">Date: {{ date }}</span>
            </v-col>

            <v-col cols="12">
              <v-btn text color="primary" @click="saleModal">
                <v-icon>mdi-plus</v-icon>Add Product To Sell
              </v-btn>


              <v-data-table light dense :items-per-page="pageItems"
                :headers="ShowBpSalesUi == 'Y' ? profitHeaders : headers" :items="orderItems" item-key="LineNum"
                hide-default-footer disable-sort :mobile-breakpoint="zeroValue" :calculate-widths="trueValue">
                <template v-slot:item.Quantity="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Quantity
                    }}
                  </span>
                </template>

                <template v-slot:item.Price="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Price.toLocaleString()
                    }}
                  </span>
                </template>

                <template v-slot:item.DisplayTotal="{ item }">
                  <span>{{ item.DisplayTotal.toLocaleString() }}</span>
                </template>

                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn @click="deleteRow(item)" color="red" icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>

          <!-- outsourced row -->
          <v-row>
            <v-col cols="12">
              <v-btn text color="primary" @click="outModal">
                <v-icon>mdi-plus</v-icon>Add Outsourced
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-data-table light dense :items-per-page="pageItems" :headers="outHeaders" :items="outArray"
                item-key="LineNum" hide-default-footer disable-sort :mobile-breakpoint="zeroValue"
                :calculate-widths="trueValue">
                <template v-slot:item.Quantity="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Quantity
                    }}
                  </span>
                </template>

                <template v-slot:item.Price="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Price.toLocaleString()
                    }}
                  </span>
                </template>

                <template v-slot:item.DisplayTotal="{ item }">
                  <span>{{ item.DisplayTotal.toLocaleString() }}</span>
                </template>

                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn @click="deleteOutRow(item)" color="red" icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>
          <!-- end of outsourced row -->

          <v-row v-show="multiplePayment == 'Y'">
            <v-col cols="12">
              <v-btn v-show="(multiplePayment == 'Y' && orderItems.length > 0) ||
                this.outArray.length > 0
                " color="primary" text @click.native="paymentDialog = true">
                <v-icon left>mdi-plus</v-icon>Add Payment
              </v-btn>
            </v-col>

            <v-col cols="12" xs="12" style="margin-top: -30px">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Account</th>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Ref No.</th>
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in payments" :key="item.account">
                      <td>{{ item.account }}</td>
                      <td>{{ item.SumApplied.toLocaleString() }}</td>
                      <td>{{ item.PaymentRemarks }}</td>
                      <td>
                        <v-btn @click="deleteAccount(item)" color="red" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-col cols="12" xs="12">
              <v-row dense class="style-16 mt-2">
                <v-col cols="12">
                  Bill:
                  <span style="float: right">{{ totalAfterDiscDisplay }}</span>
                </v-col>
              </v-row>

              <v-divider></v-divider>

              <v-row dense class="style-16 mt-2">
                <v-col cols="12">
                  Paid:
                  <span style="float: right">{{ mPaid }}</span>
                </v-col>
              </v-row>

              <v-divider></v-divider>

              <v-row dense class="style-16 mt-2">
                <v-col cols="12">
                  Balance:
                  <span style="float: right">{{ displayMBalance }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>

            <v-col cols="12">
              <v-autocomplete v-show="SelectSalesPerson == 'Y'" class="mt-2 " autocomplete="off" dense outlined
                v-model="record.SoldBy" :items="users" label="Sold By" item-text="name" item-value="id">
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-btn color="primary" @click="sendData" :loading="loader">
                <v-icon left>mdi-content-save</v-icon>Save Sale
              </v-btn>
            </v-col>
          </v-row>

          <!-- Payment dialog -->
          <v-dialog v-model="paymentDialog">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Record Payment</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="paymentDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" xs="12">
                      <v-autocomplete autocomplete="off" hide-details dense outlined v-model="paymentItem.o_a_c_t_s_id"
                        :items="accounts" label="Account" item-text="Name" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12">
                      <v-text-field autocomplete="off" type="text" v-model="paymentItem.SumApplied" label="Amount Paid"
                        outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12">
                      <v-text-field autocomplete="off" type="text" v-model="paymentItem.PaymentRemarks" label="Ref / No"
                        outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="primary" @click="addPayment" :loading="loader">
                        <v-icon left>mdi-plus</v-icon>Add Payment
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of payment modal-->

          <!-- Sale dialog -->
          <v-dialog v-model="saleDialog">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Product Selection</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="saleDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row>
                    <v-col cols="12" xs="12" md="4">
                      <v-autocomplete autocomplete="off" dense outlined single-line v-model="saleItem.id"
                        :items="products" label="Select Product" item-text="Name" item-value="id"
                        :search-input.sync="searchProducts" @change="setOrderItem">

                        <template v-slot:item="data" v-if="ShowAvailableStock == 'Y'">
                          <v-list-item-content >
                            <v-list-item-title>{{ smsRef == 'pharmacy' ? data.item.full_name : data.item.Name
                              }}</v-list-item-title>
                            <v-list-item-subtitle v-show="ShowAvailableStock == 'Y'" :v-html="`Available Qty: ${data.item.AvailableQty}`">Available Qty: {{
                              data.item.AvailableQty }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" xs="6" md="6" style="margin-top: -20px">
                      <v-text-field autocomplete="off" type="text" v-model="saleItem.Quantity"
                        @input="qtyChanged(saleItem)" label="Qty" outlined dense></v-text-field>
                    </v-col>

                    <v-col v-if="ProductsHaveUom == 'Y'" cols="6" xs="6" md="6" style="margin-top: -20px">
                      <v-text-field autocomplete="off" type="text" name="goodsReceiptUom" filled outlined readonly dense
                        value="Unit(s)" v-if="saleItem.ManualStatus == 'Y'"></v-text-field>
                      <v-autocomplete autocomplete="off" v-else dense outlined single-line v-model="saleItem.UomEntry"
                        :items="saleItem.ugp1" label="UOM" item-text="UomName" item-value="UomId"
                        @change="uomChanged(saleItem, saleItem.ugp1)"></v-autocomplete>
                    </v-col>

                    <v-col v-if="ShowBpSalesUi == 'Y'" cols="6" xs="12" md="4" style="margin-top: -20px">
                      <v-text-field autocomplete="off" type="text" v-model="saleItem.BuyingPrice" label="Buying Price"
                        readonly filled outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="12" md="4" style="margin-top: -20px">
                      <v-text-field autocomplete="off" type="text" v-model="saleItem.Price" label="Selling Price"
                        @input="qtyChanged(saleItem)" outlined dense></v-text-field>
                    </v-col>

                    <v-col v-if="ShowBpSalesUi == 'Y'" cols="6" xs="12" md="4" style="margin-top: -10px">
                      Profit: {{ saleItem.LineProfit && saleItem.LineProfit.toLocaleString() }}
                    </v-col>

                    <v-col cols="12" xs="12">
                      <span class="style-16">Total: {{ saleItem.DisplayTotal }}</span>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="primary" @click="addProduct" :loading="loader">
                        <v-icon left>mdi-plus</v-icon>Add To List
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal-->

          <!-- Outsourced dialog -->
          <v-dialog v-model="outsourcedDialog">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Outsourced Product</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="outsourcedDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row>
                    <v-col cols="12" xs="12" md="4">
                      <v-text-field autocomplete="off" type="text" v-model="outItem.Name" label="Name" outlined
                        dense></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="5" md="4">
                      <v-text-field autocomplete="off" type="number" v-model="outItem.Quantity"
                        @input="qtyOutChanged(outItem)" label="Qty" outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="7" md="4">
                      <v-text-field autocomplete="off" type="number" v-model="outItem.BuyingPrice"
                        @input="qtyOutChanged(outItem)" label="Buying Price" outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="7" md="4">
                      <v-text-field autocomplete="off" type="number" v-model="outItem.Price"
                        @input="qtyOutChanged(outItem)" label="Selling Price" outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12">Total: {{ outItem.DisplayTotal }}</v-col>

                    <v-col cols="12">
                      <v-btn color="primary" @click="addOutProduct" :loading="loader">
                        <v-icon left>mdi-plus</v-icon>Add To List
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of outsourced modal-->

          <!-- Customer quick add dialog -->
          <v-dialog v-model="customerDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Create A Customer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="customerDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <customer-editor :initial="accountItem" @data="saveCustomer"></customer-editor>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <!-- product quick add dialog -->
          <v-dialog v-model="productDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Create A Product</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="productDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <product-editor :docCreate="true" :initial="productItem" @data="saveProduct"></product-editor>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <!-- snackbar -->
          <snackbar ref="snackbar"></snackbar>
        </v-card-text>
      </v-card>
    </div>

    <div v-show="sellOnline == 'N'">
      <span style="color: orange; font-size: 14">Selling online not enabled for this account, please sell using the
        offline
        version for receipt numbers to be consistent.</span>
    </div>

  </v-container>
</template>

<script>
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
import ProductEditor from "@/components/subscriber/products/creation/_components/quick-editor.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "PosPortal",
  components: {
    CustomerEditor,
    ProductEditor
  },
  props: {
    docCreate: {
      type: Boolean
    },
    loaderOff: {
      type: Boolean
    },
    copyStatus: {
      type: Boolean
    }
  },
  data: () => ({
    zeroValue: 0,
    sellOnline: "Y",
    ProductsHaveUom: "",
    ShowBpSalesUi: "",
    SelectSalesPerson: "",
    enableCreate: true,
    customerDialog: false,
    productDialog: false,
    productItem: {},
    accountItem: {},
    trueValue: true,
    searchingProduct: false,
    searchProducts: null,
    searchCustomers: null,
    record: {},
    outsourcedDialog: false,
    outItem: {},
    outArray: [],
    UserSign: null,
    enablePriceList: "N",
    ShowAvailableStock: "",
    saleDialog: false,
    SellDeficit: "",
    saleItem: {},
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    date: new Date().toISOString().substr(0, 10),
    todayDate: new Date().toISOString().substr(0, 10),
    generalSettings: {},
    dateReadonly: "",
    clearDate: "",
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Uom", value: "uomEntryName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ],
    profitHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "B Price", value: "BuyingPrice" },
      { text: "S. Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "B. Price", value: "BuyingPrice" },
      { text: "S. Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ],
    paymentHeaders: [
      { text: "Account", value: "account" },
      { text: "Amount", value: "SumApplied" },
      { text: "Ref No.", value: "PaymentRemarks" },
      { text: "Action", value: "action" }
    ]
  }),
  computed: {
    canBackDate() {
      return localStorage.getItem("canBackDate");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    outTotalAmount() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map(item => {
            const amount = parseFloat(item.SumApplied);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAfterDisc;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }

      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }

      const balance =
        this.totalAmount +
        this.outTotalAmount -
        parseFloat(sum) -
        parseFloat(disc);
      return balance;
    },
    totalAfterDisc() {
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const total = this.totalAmount + this.outTotalAmount - parseFloat(disc);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    displayBalance() {
      return this.balance.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    }
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    saleModal() {
      this.saleItem = {};
      this.saleDialog = true;
    },
    productModal() {
      this.productDialog = true;
    },
    customerModal() {
      this.customerDialog = true;
    },
    outModal() {
      this.outItem = {};
      this.outsourcedDialog = true;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      if (this.record.CardCode) {
        customerId = this.record.CardCode;
      }

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null && res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      console.log(searchText);
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveProduct(data) {
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getProducts();
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCustomer(data) {
         var storeId = parseInt(this.activeStore);
      data.store_id = storeId;
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // const customer = res.ResponseData;
            // self.customers = [...this.customers, customer];
            // self.record.CardCode = customer.id;
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    addProduct() {
      if (this.saleItem.Price < this.saleItem.LowerLimit) {
        const msg = `You can not sell below ${this.saleItem.LowerLimit}`;
        this.$refs.snackbar.show(msg, "red");
      } else {
        if (
          this.saleItem.Quantity > this.saleItem.available &&
          this.SellDeficit == "N"
        ) {
          this.$refs.snackbar.show(
            `Insufficient Stock Available: ${this.saleItem.available}`,
            "red"
          );
        } else {
          const self = this;
          const initArray = [];
          initArray.push(self.saleItem);
          self.orderItems = [...self.orderItems, ...initArray];
          this.saleItem = {};
          this.saleDialog = false;
        }
      }
    },
    addOutProduct() {
      if (
        this.outItem.Name == undefined ||
        this.outItem.Quantity == undefined ||
        this.outItem.Price == undefined ||
        this.outItem.BuyingPrice == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields!", "red");
      } else {
        const self = this;
        const initArray = [];
        self.outItem.LineNum = `${new Date().getTime()}-${Math.random()}`;
        self.outItem.Commission = 0;

        // console.log()
        // handle buying price
        var buyingPrice = 0;
        self.LineProfit = 0;
        if(this.outItem.BuyingPrice == undefined && this.outItem.BuyingPrice == null) {
          buyingPrice = parseFloat(this.outItem.BuyingPrice);
        }

        const TotalBuyingPrice =
        parseFloat(this.outItem.Quantity) * buyingPrice;

        // end of 
        const LineTotal =
          parseFloat(this.outItem.Quantity) * parseFloat(this.outItem.Price);
        self.outItem.LineTotal = LineTotal;

        const LineProfit = LineTotal - TotalBuyingPrice;
        self.outItem.LineProfit = LineProfit;

        initArray.push(self.outItem);
        self.outArray = [...self.outArray, ...initArray];
        this.outItem = {};
        this.outsourcedDialog = false;
      }
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const paymentAccount = this.payments.find(record => {
            return record.o_a_c_t_s_id === accoutId;
          });

          if (paymentAccount == undefined) {
            const item = this.paymentItem;
            const account = this.accounts.find(record => {
              return record.id === accoutId;
            });
            // check if payment mode exist

            const data = {
              o_a_c_t_s_id: account.id,
              account: account.Name,
              SumApplied: item.SumApplied,
              PaymentRemarks: item.PaymentRemarks
            };
            this.payments.push(data);
            this.paymentItem = {};
            this.paymentDialog = false;
          } else {
            this.$refs.snackbar.show("That payment mode exist!", "red");
          }
          // end of check
        }
      }
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find(record => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    deleteOutRow(item) {
      const selectedRow = this.outArray.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.outArray.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.outArray.splice(pos, 1);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    qtyChanged(data) {
      let BuyingPrice = 0;
      let Price;
      let Quantity;

      if (data.BuyingPrice) {
        BuyingPrice = parseFloat(data.BuyingPrice);
      } else {
        BuyingPrice = 0;
      }

      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }

      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const TotalBuyingPrice = BuyingPrice * Quantity;
      const LineTotal = Price * Quantity;

      const LineProfit = LineTotal - TotalBuyingPrice;
      const DisplayTotal = LineTotal.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      // find item

      this.saleItem.LineTotal = LineTotal;
      this.saleItem.LineProfit = LineProfit;
      this.saleItem.DisplayTotal = DisplayTotal;
    },
    qtyOutChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.outItem.LineTotal = LineTotal;
      this.outItem.DisplayTotal = DisplayTotal;
    },
    inputChanged(data) {
      if (parseFloat(data.Price) < parseFloat(data.BuyingPrice)) {
        this.$refs.snackbar.show(
          `You cannot sell below ${data.BuyingPrice}`,
          "red"
        );
      } else {
        let Price;
        let Quantity;
        let DiscSum;
        if (data.Price) {
          Price = parseFloat(data.Price);
        } else {
          Price = 0;
        }
        if (data.Quantity) {
          Quantity = parseFloat(data.Quantity);
        } else {
          Quantity = 0;
        }

        if (data.DiscSum) {
          DiscSum = parseFloat(data.DiscSum);
        } else {
          DiscSum = 0;
        }

        const TotalBefTax = Price * Quantity;

        // add tax
        const tax = this.taxGroups.find(record => {
          return record.id === data.TaxId;
        });

        let taxAmount = 0;
        let taxRate = 0;
        if (tax) {
          taxRate = tax.Rate;
          taxAmount = (taxRate / 100) * TotalBefTax;
        }

        const TotalAfterTax = TotalBefTax + taxAmount;

        const LineTotal = TotalAfterTax - DiscSum;

        const DisplayTotal = LineTotal.toLocaleString();
        // find item
        const currentItem = this.orderItems.find(record => {
          return record.LineNum === data.LineNum;
        });

        const pos = this.orderItems.indexOf(currentItem);
        if (pos === -1) {
          return;
        }
        // end of find

        // update record
        currentItem.TaxRate = taxRate;
        currentItem.TaxAmount = taxAmount;
        currentItem.LineTotal = LineTotal;
        currentItem.DisplayTotal = DisplayTotal;
        this.orderItems[pos] = currentItem;
      }
    },
    uomChanged(item, ugp1) {
      const ugp1Record = ugp1.find(record => {
        return record.UomEntry === item.UomEntry;
      });

      if (ugp1Record) {
        this.saleItem.uomEntryName = ugp1Record.UomName;
        this.saleItem.Price = ugp1Record.SellingPrice;
      }
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;

      var customerId = this.record.CardCode;

      if (customerId == undefined) {
        customerId = 0;
      }

      var data = {
        CustomerId: parseInt(customerId),
        ProductId: parseInt(id)
      };

      var url = `/product-prices`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            // current item definition
            let currentItem = {};
            currentItem.Quantity = 1;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.SUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              const total = 1 * parseFloat(sellingPrice);
              currentItem.LineTotal = total;
              var profit = sellingPrice - buyingPrice;
              currentItem.LineTotal = total;
              currentItem.LineProfit = profit;
              currentItem.DisplayTotal = total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.SellingPrice;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.SellingPrice;
              const total = 1 * ugp1Record.SellingPrice;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });

              // push to array
              this.select = "";
              self.products = [];
              // end of push
            }

            self.saleItem = { ...self.saleItem, ...currentItem };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    sendData() {
      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length <= 0 && this.outArray.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      if (this.SelectSalesPerson == "Y" && this.record.SoldBy == null) {
        this.$refs.snackbar.show("Please select the seller", "red");
        return;
      }

      let balance = 0;
      if (this.multiplePayment == "N") {
        balance = this.totalAfterDisc - this.SumApplied;
      } else {
        balance = this.mBalance;
      }

      if (balance > 0 && this.record.CardCode == undefined) {
        this.$refs.snackbar.show("Please select customer", "red");
        return;
      }

      // get user id
      const userId = parseInt(localStorage.getItem("user_id"));

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;

      var uniqueId = this.generateUniqueId();
      // end of unique id

      var soldBy = userId;

      if (this.SelectSalesPerson == "Y") {
        soldBy = parseInt(this.record.SoldBy);
      }

      data.LocalId = uniqueId;
      data.UniqueId = uniqueId;
      data.TargetType = null;
      data.BaseType = 0;
      data.BaseEntry = null;
      data.ObjType = 14;
      data.DocTotal = this.totalAmount + this.outTotalAmount;
      data.DocNum = this.DocNum;
      data.UserSign = parseInt(userId);
      data.SoldBy = parseInt(soldBy);
      data.ref2 = this.ref2;
      // data.seller = seller.name;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.HeldOrderID = 0;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          BuyingPrice: parseFloat(row.BuyingPrice),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: storeId
        };

        rows.push(details);
      }
      // end

      data.rows = rows;

      // append outsource rows
      var outsourceData = this.outArray;
      var outRows = [];
      for (const row of outsourceData) {
        var outDetails = {
          Name: row.Name,
          Quantity: parseFloat(row.Quantity),
          BuyingPrice: parseFloat(row.BuyingPrice),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          LineProfit: parseFloat(row.LineProfit)
        };

        outRows.push(outDetails);
      }

      data.outRows = outRows;

      let Dis = 0;
      if (this.DiscOnTotal == null) {
        Dis = 0;
      } else {
        Dis = this.DiscOnTotal;
      }
      data.DiscSum = Dis;
      data.totalAfterDisc = this.totalAfterDisc;
      if (this.multiplePayment == "N") {
        data.TotalPaid = this.SumApplied;
        data.Balance = this.balance;
      } else {
        data.TotalPaid = this.mTotalPayments;
        data.Balance = this.mBalance;
      }

      data.userName = this.userName;

      let tenderPayments = [];
      if (this.payments.length > 0) {
        const paymentsArray = this.payments;
        for (const account of paymentsArray) {
          if (account.SumApplied) {
            let details = {
              storeId: storeId,
              o_a_c_t_s_id: parseInt(account.o_a_c_t_s_id),
              Amount: parseFloat(account.SumApplied),
              PaymentRemarks: "",
              PaymentPhone: ""
            };
            tenderPayments.push(details);
          }
        }
      }

      // prepare payments
      data.payments = tenderPayments;

      // get customer details
      let CardCode = this.record.CardCode;
      const selectedCustomer = this.customers.find(record => {
        return record.id === CardCode;
      });

      let custName = "";
      let custPhone = "";
      let custAddress = "";

      if (selectedCustomer) {
        custName = selectedCustomer.Name;
        custPhone = selectedCustomer.PhoneNumber;
        custAddress = selectedCustomer.Address;
      }

      data.deliveryCustomer = custName;
      data.deliveryPhone = custPhone;
      data.deliveryAddress = custAddress;
      data.depositId = 0;

      // compute delivery charges
      const deliveryItems = this.orderItems.filter(record => {
        return record.itemType == "C";
      });

      let totalDelivery = 0;
      if (typeof deliveryItems != "undefined" && deliveryItems.length > 0) {
        totalDelivery = deliveryItems
          .map(item => {
            const amount = parseFloat(item.LineTotal);
            totalDelivery = +amount;
            return totalDelivery;
          })
          .reduce((val, a) => {
            return val + a;
          });
      }

      data.totalDelivery = totalDelivery;
      // end

      // save data
      const url = "/create-document";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.outArray = [];
            self.SumApplied = 0;
            self.payments = [];
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            this.$refs.snackbar.show("Sale successful", "green");
            self.loader = false;
            self.getAccounts();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
      // balance < 0 curly brace
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
            self.SoldBy = res.ResponseData.SoldBy;
            self.SellDeficit = res.ResponseData.SellDeficit;
            self.clearDate = res.ResponseData.clearDate;
            self.dateReadonly = res.ResponseData.dateReadonly;
            self.enablePriceList = res.ResponseData.enablePriceList;
            self.SelectSalesPerson = res.ResponseData.SelectSalesPerson;
            self.ShowBpSalesUi = res.ResponseData.ShowBpSalesUi;
            self.ProductsHaveUom = res.ResponseData.ProductsHaveUom;
            self.ShowAvailableStock = res.ResponseData.ShowAvailableStock;

            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
      this.getAccounts(),
      this.getUsers()
    ]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>